import type { ICandidate, IExperienceFlat } from "@bbj-types/candidate";
import type { Override } from "@bbj-types/utils";
import { useCallback } from "react";
import { axios } from "./axios";

export type ICreateCandidate = Override<
  Omit<
    ICandidate,
    | "_id"
    | "profileId"
    | "applicationFiles"
    | "cerLegacy"
    | "cer"
    | "organisation"
    | "createdAt"
    | "updatedAt"
    | "status"
    | "diagnoses"
    | "documents"
    | "coachingStep"
    | "new"
    | "isArchived"
    | "eptReorientation"
    | "eptRenewal"
    | "__v"
    | "interviewExits"
  >,
  { authors: string[]; experiences: IExperienceFlat[]; skills?: string[]; team?: string }
>;

export const useCreateCandidate = () => {
  const [state, execute, cancel] = axios<ICandidate, ICreateCandidate, unknown>(
    {
      url: "/candidates",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: ICreateCandidate) => {
      return execute({
        url: "/candidates",
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
